export default "__VITE_ASSET__5c6e057e__"